import React, { useEffect, useState } from "react";
import LangStorageManager from '../lang/LangStorageManager';
import LanguageManager from '../lang/LanguageManager';
import './info.css';

export default function Info(){
    const storage = new LangStorageManager(null);
    const[language, setLanguage] = useState(storage.getStorage());
    const[texts, setTexts] = useState(null);

    useEffect(() => {
        const loadText = async () => {
            const translator = new LanguageManager(storage.getStorage());
            await translator.loadTranslation();
            setTexts(translator.getAll());
        };
        loadText();
    }, [language]);

    return(
        <section id="about-me">
            <h2>Nahuel Tellechea Freire</h2>
            <div className="content">
                <img src="/img/photo.jpg" alt="Photo" title="Profile picture" />
                <p>{texts?.info?.bio || "Hi! I'm Nahuel, a web and software developer in training.\nI enjoy creating things from scratch, writing code that works (and understanding why it works), and finding simple solutions to complex problems.\nI graduated as a Web Developer from the Universidad del Trabajo del Uruguay (UTU), and I’m currently studying Information Technology at the Universidad Tecnológica del Uruguay (UTEC).\nAlthough I’m still building my first projects, I’m fully focused on learning, improving every day, and continuing to grow."}</p>
            </div>
        </section>
    );
}